import { mq } from '@phishtool/ui';
import styled from 'styled-components';
export const StyledCookieBannerWrapper = styled.div.withConfig({ displayName: "StyledCookieBannerWrapper", componentId: "sc-11r43mx" }) `
  background: ${(props) => props.theme.colors.white};
  padding: ${(props) => props.theme.spacers.x3};
  border-radius: ${(props) => props.theme.radii.primary};
  position: fixed;
  bottom: ${(props) => props.theme.spacers.x3};
  right: ${(props) => props.theme.spacers.x3};
  z-index: 1;

  ${(props) => mq({
    boxShadow: props.theme.shadows.tertiary,
    width: ['auto', '382px'],
    left: [props.theme.spacers.x3, 'auto'],
})}
`;
export const StyledCookieBannerHeading = styled.h3.withConfig({ displayName: "StyledCookieBannerHeading", componentId: "sc-1mpjrbh" }) `
  font-size: ${(props) => props.theme.typography.x5.fontSize};
  letter-spacing: ${(props) => props.theme.typography.x5.letterSpacing};
  font-weight: ${(props) => props.theme.fontWeights.semiBold};
  margin: 0 0 ${(props) => props.theme.spacers.x3};
`;
